/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Sorts an array of items by a property key in ascending or descending order.
 * Replaces lodash orderBy to avoid CommonJS optimization bailouts.
 */
function orderBy<T>(items: T[], key: string, direction: 'asc' | 'desc'): T[] {
  return [...items].sort((a, b) => {
    const aVal = (a as any)[key];
    const bVal = (b as any)[key];
    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return 1;
    if (bVal == null) return -1;
    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  });
}

export class Sortable<T> {
  items: T[] = [];
  allItems: T[] = [];
  column?: string;
  ascending?: boolean;
  searchQuery?: string;

  constructor(data?: T[], column?: string, ascending?: boolean) {
    this.column = column;
    this.ascending = ascending;

    this.init(data || []);
  }

  mutate(data: T[]) {
    this.items = [];
    setTimeout(() => {
      this.init(data);
    });
  }

  init(data: T[]) {
    this.allItems = !data ? [] : (JSON.parse(JSON.stringify(data)) as T[]);
    this.items = JSON.parse(JSON.stringify(this.allItems)) as T[];
    if (this.column) {
      this.sort(this.column || '', this.ascending);
    }
  }

  public search() {
    if (this.searchQuery && this.searchQuery?.length > 0) {
      const items: any[] = [];
      const query = this.searchQuery?.toLowerCase() || '';
      this.allItems.forEach((row) => {
        const rowJson = JSON.stringify(row);
        if (rowJson.toLowerCase().indexOf(query) >= 0) {
          items.push(JSON.parse(rowJson) as T);
        }
      });
      this.items = items as unknown as T[];
    } else {
      this.items = JSON.parse(JSON.stringify(this.allItems)) as T[];
      this.column && this.sort(this.column, false);
    }
  }

  public sort(expr: string, toggleAscending = true) {
    if (toggleAscending) {
      this.ascending = !this.ascending;
    }

    this.column = expr;
    //console.log('sorting ascending = ' + this.ascending + ' on ' + expr);

    if (this.ascending) {
      this.items = orderBy(this.items, this.column, 'asc');
    } else {
      this.items = orderBy(this.items, this.column, 'desc');
    }
  }
}
